// alterado - revisado

import React from 'react'

import {
    ListRadioGroup,
} from '../../business-components/RadioGroup/RadioGroup'

import morteInvalidezEstudoList from '../List/morteInvalidezEstudoList'

export const MorteInvalidezEstudoRadioGroup = props => {
    return (
        <ListRadioGroup
            list={morteInvalidezEstudoList(props.values)}
            {...props}
        />
    )
}